    (function () {
      document.addEventListener('DOMContentLoaded', function () {
        const wrapper = document.querySelector('.shipping-info_wrapper');
        if (!wrapper) return;

        const titleEl  = wrapper.querySelector('#shipping-info-title');
        const textEl   = wrapper.querySelector('#shipping-info-text');
        const pillEl   = wrapper.querySelector('#shipping-info-pill');
        const iconEl   = wrapper.querySelector('#shipping-info-icon');
        const bottomEl = wrapper.querySelector('#shipping-info-bottom');

        const cutoffHour = parseInt(wrapper.dataset.cutoffHour || '13', 10);
        const dayLabels = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

        const ICONS = {
          before: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z"/><path d="M12 12l8-4.5"/><path d="M12 12v9"/><path d="M12 12L4 7.5"/><path d="M16 5.25l-8 4.5"/></svg>',
          after:  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/><path d="M5 17H3V6a1 1 0 0 1 1-1h9v12m0 0h2m2 0h2m0 0V9.5l3 3.5v4h-3"/></svg>',
          weekend:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="5" width="16" height="16" rx="2"/><path d="M16 3v4"/><path d="M8 3v4"/><path d="M4 11h16"/><rect x="8" y="15" width="2" height="2"/></svg>'
        };

        function getCountdownToCutoff() {
          const now = new Date();
          const cutoff = new Date();
          cutoff.setHours(cutoffHour, 0, 0, 0);
          const distance = cutoff - now;
          if (distance <= 0) return null;
          const h = Math.floor(distance / 3600000);
          const m = Math.floor((distance % 3600000) / 60000);
          return h + 'h ' + m + 'm';
        }

        function getNextSlotCountdown() {
          const now = new Date();
          const next = new Date(now);
          next.setDate(now.getDate() + 1);
          next.setHours(cutoffHour, 0, 0, 0);
          const diff = next - now;
          const h = Math.floor(diff / 3600000);
          const m = Math.floor((diff % 3600000) / 60000);
          return h + 'h ' + m + 'm';
        }

        function getProgressPercent() {
          const now = new Date();
          const hours = now.getHours() + now.getMinutes() / 60 + now.getSeconds() / 3600;
          return Math.min(100, Math.max(0, (hours / cutoffHour) * 100));
        }

        function getDaysUntilMonday() {
          const d = new Date().getDay();
          if (d === 5) return 3; // Fr nach Cutoff
          if (d === 6) return 2; // Sa
          if (d === 0) return 1; // So
          return 1;
        }

        function buildDayStrip() {
          const now = new Date();
          const daysAhead = getDaysUntilMonday();
          let html = '<div class="shipping-info_days">';
          for (let i = 0; i <= daysAhead; i++) {
            const d = new Date(now);
            d.setDate(now.getDate() + i);
            const isToday = i === 0;
            const isShip = i === daysAhead;
            let cls = 'shipping-info_day';
            if (isToday) cls += ' is-today';
            if (isShip) cls += ' is-ship';
            const tag = isToday ? '<div class="shipping-info_day-tag">heute</div>' : '';
            html += '<div class="' + cls + '">' + tag +
              '<div class="shipping-info_day-l">' + dayLabels[d.getDay()] + '</div>' +
              '<div class="shipping-info_day-n">' + d.getDate() + '</div>' +
              '</div>';
          }
          return html + '</div>';
        }

        function determineState() {
          const now = new Date();
          const day = now.getDay();
          const hour = now.getHours();
          const isFridayAfterCutoff = day === 5 && hour >= cutoffHour;
          const isWeekend = day === 6 || day === 0;
          const isWeekday = day >= 1 && day <= 5;
          if (isWeekend || isFridayAfterCutoff) return 'weekend';
          if (isWeekday && hour < cutoffHour) return 'before';
          return 'after';
        }

        function renderState(state) {
          iconEl.innerHTML = ICONS[state];

          if (state === 'before') {
            const cd = getCountdownToCutoff() || '0m';
            titleEl.innerHTML = (wrapper.dataset.titleBefore || '').replace(
              '[countdown]',
              '<span class="shipping-info_countdown notranslate">' + cd + '</span>'
            );
            textEl.textContent = wrapper.dataset.textBefore || '';
            pillEl.textContent = cd;
            bottomEl.innerHTML =
              '<div class="shipping-info_track"><div class="shipping-info_fill" style="width:' + getProgressPercent() + '%"></div></div>' +
              '<div class="shipping-info_axis"><span>jetzt</span><span>cutoff &middot; ' + cutoffHour + ':00</span></div>';
          } else if (state === 'weekend') {
            titleEl.textContent = wrapper.dataset.titleWeekend || '';
            textEl.textContent = wrapper.dataset.textWeekend || '';
            const days = getDaysUntilMonday();
            pillEl.textContent = '+' + days + (days === 1 ? ' Tag' : ' Tage');
            bottomEl.innerHTML = buildDayStrip();
          } else {
            titleEl.textContent = wrapper.dataset.titleAfter || '';
            textEl.textContent = wrapper.dataset.textAfter || '';
            pillEl.textContent = 'morgen';
            bottomEl.innerHTML =
              '<div class="shipping-info_next">' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>' +
              '<span>N&auml;chster Versand-Slot in <strong class="notranslate">' + getNextSlotCountdown() + '</strong></span>' +
              '</div>';
          }
        }

        function updateLive() {
          if (currentState === 'before') {
            const cd = getCountdownToCutoff();
            if (cd) {
              const span = titleEl.querySelector('.shipping-info_countdown');
              if (span) span.textContent = cd;
              pillEl.textContent = cd;
              const fill = bottomEl.querySelector('.shipping-info_fill');
              if (fill) fill.style.width = getProgressPercent() + '%';
            }
          } else if (currentState === 'after') {
            const strong = bottomEl.querySelector('strong');
            if (strong) strong.textContent = getNextSlotCountdown();
          }
        }

        let currentState = null;
        let currentDay = null;

        function tick() {
          const newState = determineState();
          const newDay = new Date().getDay();
          if (newState !== currentState || newDay !== currentDay) {
            currentState = newState;
            currentDay = newDay;
            renderState(newState);
          } else {
            updateLive();
          }
        }

        tick();
        setInterval(tick, 1000);
      });
    })();